$(function () {
    window.loadDataTables = function () {
        if (!$.fn.DataTable) {
            return;
        }

        $('.dataTables-1').each(function () {
            if (!$.fn.DataTable.isDataTable(this)) {
                $(this).DataTable({
                    pageLength: 50,
                    responsive: false,
                    aaSorting: [],
                    dom: '<"html5buttons"B>lTfgitp',
                    buttons: []
                });
            }
        });
    };

    window.loadDataTablesPrint = function () {
        if (!$.fn.DataTable) {
            return;
        }

        $('.dataTables-print').each(function () {
            if (!$.fn.DataTable.isDataTable(this)) {
                $(this).DataTable({
                    pageLength: 50,
                    responsive: false,
                    aaSorting: [],
                    dom: '<"html5buttons"B>lTfgitp',
                    buttons: ['copyHtml5', 'excelHtml5', 'pdfHtml5', 'print']
                });
            }
        });
    };

    if ($('.dataTables-1').length) {
        window.loadDataTables();
    }

    if ($('.dataTables-print').length) {
        window.loadDataTablesPrint();
    }

    $(document).on('click', '.down-cat-id', function () {
        var filterValue = $(this).val();
        var downloadsUrl = $('#downloads_url').val();
        var query = filterValue ? '?cat_id=' + encodeURIComponent(filterValue) : '';

        window.location.href = downloadsUrl + query;
    });

    $(document).on('click', '.btn-collapse', function () {
        var icon = $(this).find('.collapse-icon');

        if (icon.hasClass('fa-plus')) {
            icon.removeClass('fa-plus').addClass('fa-minus');
        } else if (icon.hasClass('fa-minus')) {
            icon.removeClass('fa-minus').addClass('fa-plus');
        } else if (icon.hasClass('fa-chevron-down')) {
            icon.removeClass('fa-chevron-down').addClass('fa-chevron-up');
        } else if (icon.hasClass('fa-chevron-up')) {
            icon.removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
    });
});
